/**
 * APIs Module Routes
 * API Management, Tokens, Catalog, Logs
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const ApiDashboard = lazy(() => import("@/pages/apis/Index"));

// Tokens
const TokenList = lazy(() => import("@/pages/apis/tokens/Index"));
const TokenCreate = lazy(() => import("@/pages/apis/tokens/Create"));
const TokenDetails = lazy(() => import("@/pages/apis/tokens/Details"));
const TokenEdit = lazy(() => import("@/pages/apis/tokens/Edit"));

// Catalog
const ApiCatalog = lazy(() => import("@/pages/apis/catalog/Index"));
const ApiDetails = lazy(() => import("@/pages/apis/catalog/Details"));
const ApiTest = lazy(() => import("@/pages/apis/catalog/Test"));

// Logs
const ApiLogs = lazy(() => import("@/pages/apis/logs/Index"));
const ApiLogDetails = lazy(() => import("@/pages/apis/logs/Details"));
const ApiLogExport = lazy(() => import("@/pages/apis/logs/Export"));

// Webhooks (integrated separately)
const WebhookList = lazy(() => import("@/pages/apis/webhooks/Index"));
const WebhookCreate = lazy(() => import("@/pages/apis/webhooks/Create"));
const WebhookDetails = lazy(() => import("@/pages/apis/webhooks/Details"));
const WebhookEdit = lazy(() => import("@/pages/apis/webhooks/Edit"));

export const apisRoutes: ModuleRoutes = {
  moduleId: "apis",
  basePath: "/apis",
  routes: [
    // Dashboard
    {
      path: "/apis",
      element: <ApiDashboard />,
      permission: { resource: "apis", action: "view" },
    },

    // Tokens Management
    {
      path: "/apis/tokens",
      element: <TokenList />,
      permission: { resource: "api_tokens", action: "view" },
    },
    {
      path: "/apis/tokens/new",
      element: <TokenCreate />,
      permission: { resource: "api_tokens", action: "create" },
    },
    {
      path: "/apis/tokens/:id",
      element: <TokenDetails />,
      permission: { resource: "api_tokens", action: "view" },
    },
    {
      path: "/apis/tokens/:id/edit",
      element: <TokenEdit />,
      permission: { resource: "api_tokens", action: "update" },
    },

    // API Catalog
    {
      path: "/apis/catalog",
      element: <ApiCatalog />,
      permission: { resource: "api_catalog", action: "view" },
    },
    {
      path: "/apis/catalog/:id",
      element: <ApiDetails />,
      permission: { resource: "api_catalog", action: "view" },
    },
    {
      path: "/apis/catalog/:id/test",
      element: <ApiTest />,
      permission: { resource: "api_catalog", action: "test" },
    },

    // API Logs
    {
      path: "/apis/logs",
      element: <ApiLogs />,
      permission: { resource: "api_logs", action: "view" },
    },
    {
      path: "/apis/logs/:id",
      element: <ApiLogDetails />,
      permission: { resource: "api_logs", action: "view" },
    },
    {
      path: "/apis/logs/export",
      element: <ApiLogExport />,
      permission: { resource: "api_logs", action: "export" },
    },

    // Webhooks (alternative path under APIs)
    {
      path: "/apis/webhooks",
      element: <WebhookList />,
      permission: { resource: "webhooks", action: "view" },
    },
    {
      path: "/apis/webhooks/new",
      element: <WebhookCreate />,
      permission: { resource: "webhooks", action: "create" },
    },
    {
      path: "/apis/webhooks/:id",
      element: <WebhookDetails />,
      permission: { resource: "webhooks", action: "view" },
    },
    {
      path: "/apis/webhooks/:id/edit",
      element: <WebhookEdit />,
      permission: { resource: "webhooks", action: "update" },
    },
  ],
};
